import React, { useState, useEffect } from "react";
import { Translate } from "react-redux-i18n";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Form, Loader } from "semantic-ui-react";
import axios from "axios";
import get from "lodash.get";

import { formatDateWithPattern } from "../../../../utils/time/formatDateWithPattern";

import config from "../../../../constants";

import { getEventAmbassadorRecord } from "../../store/vipProgramActions";
import CurrencyHelper from "../../../../helpers/currencyHelper";
import SystemOnlyBadge from "../../../../components/common/SystemOnlyBadge";

import "./partOneInfo.css";

export const PartOneInfo = (props) => {
  const {
    dateReceived,
    fundraiserRaisedAmount,
    fundraiserId,
    fundraiserName,
    eventName,
    eventAmbassadorId,
    eventAmbassadorProgramName,
    isChangeLinkedPageModalOpen,
    onCloseChangeLinkedPageModal,
    organizationName
  } = props;

  const session = useSelector(state => get(state, "session"));
  const eventAmbassador = useSelector(state => get(state, "program.eventAmbassadorRecord.data.data"));
  const currency = get(eventAmbassador, "organization.currency");

  const isSystemAdmin = useSelector(state => get(state, "session.isSystemAdmin"));

  const [modalLoading, setModalLoading] = useState(false);
  const [modalOptions, setModalOptions] = useState([]);
  const [selectedFundraiser, setSelectedFundraiser] = useState(fundraiserId);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isChangeLinkedPageModalOpen) {
      (async () => {
        setModalLoading(true);
        const result = await axios.post(
          `${config.baseApiHost}/api/v3/page/search`,
          {
            page: 1,
            pageSize: 10,
            resultType: "Full",
            baseObjectsOnly: true,
            filters: [
              {
                key: "campaignId",
                operator: "EqualTo",
                value: [get(eventAmbassador, "campaignId")]
              },
              {
                key: "isActive",
                operator: "EqualTo",
                value: ["true"]
              },
              {
                key: "accountId",
                operator: "EqualTo",
                value: [get(eventAmbassador, "accountId")]
              },
              {
                key: "fundraiserId",
                operator: "NotEqualTo",
                value: [get(eventAmbassador, "fundraiserId")]
              },
              {
                key: "type",
                operator: "EqualTo",
                value: ["fundraiser"]
              }
            ]
          },
          {
            headers: {
              ApiKey: config.apikey,
              Authorization: `bearer ${session.key}`,
            },
          }
        );

        if (result.data.success) {
          setSelectedFundraiser(fundraiserId);
          setModalOptions([
            {
              value: fundraiserId,
              text: `(Current page) - ${fundraiserName} (${fundraiserId}) - ${CurrencyHelper.formatCurrency(fundraiserRaisedAmount, currency)}`,
            },
            ...result.data.data.list.map(item => ({
              value: item.fundraiserId,
              text: `${item.name} (${item.fundraiserId}) - ${CurrencyHelper.formatCurrency(item.raisedAmount, currency)}`,
            })),
          ]);
        }

        setModalLoading(false);
      })();
    }
  }, [isChangeLinkedPageModalOpen]);

  const handleChangeFundraiser = async () => {
    setModalLoading(true);

    const result = await axios.put(
      `${config.baseApiHost}/api/v2/eventAmbassador/${eventAmbassadorId}/fundraiser`,
      { fundraiserId: selectedFundraiser, },
      {
        headers: {
          ApiKey: config.apikey,
          Authorization: `bearer ${session.key}`,
        },
      }
    );

    if (result.data.success) {
      onCloseChangeLinkedPageModal();
      dispatch(getEventAmbassadorRecord(eventAmbassadorId));
    }

    setModalLoading(false);
  };

  return (
    <>
      <div className="template-content-container">
        <div className="template-name">
          <strong>
            <Translate value="applications.template.page.partOne.event-name.label" />
          </strong>
          <span>{eventName}</span>
        </div>

        <div className="template-name">
          <strong>
            <Translate value="applications.template.page.partOne.program-name.label" />
          </strong>
          <span>{eventAmbassadorProgramName}</span>
        </div>

        {isSystemAdmin && <div className="template-name">
          <strong>
            <Translate value="applications.template.page.partOne.organization-name.label" />
            <SystemOnlyBadge />
          </strong>
          <span>{organizationName}</span>
        </div>}

        <div className="template-date">
          <strong>
            <Translate value="applications.template.page.partOne.date-received.label" />
          </strong>{' '}
          {formatDateWithPattern(dateReceived, config.DEFAULT_FULL_DATE_TIME_PERIODS_FORMAT)}
        </div>

      </div>
      <Modal
        className="wizard"
        dimmer="inverted"
        size="tiny"
        open={isChangeLinkedPageModalOpen}
        onClose={onCloseChangeLinkedPageModal}
      >
        <Modal.Header>
          <Translate value="applications.template.page.partOne.change-page-modal.header" />
        </Modal.Header>
        <Modal.Content>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <Translate
              style={{
                marginBottom: "2rem",
                display: "flex",
                flexDirection: "column",
              }}
              value="applications.template.page.partOne.change-page-modal.description"
            />
            {modalLoading ? (
              <Loader
                active
                inline
              />
            ) : (
              <Form.Dropdown
                selection
                value={selectedFundraiser}
                options={modalOptions}
                onChange={(event, data) => setSelectedFundraiser(data.value)}
              />
            )}
          </div>
          <div
            style={{
              marginTop: "2rem",
              textAlign: "center",
            }}
          >
            <Button
              primary
              disabled={modalLoading}
              onClick={handleChangeFundraiser}
            >
              <Translate value="applications.template.page.partOne.change-page-modal.confirm" />
            </Button>
            <Button
              style={{
                width: 95,
              }}
              onClick={onCloseChangeLinkedPageModal}
            >
              <Translate value="applications.template.page.partOne.change-page-modal.close" />
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    </>
  );
};
